module.exports = __webpack_public_path__ + "img/kategoria_naukajezykow.61f3929a.jpg";